import { Location } from "@angular/common";
import {
    HttpErrorResponse,
    HttpInterceptorFn,
    HttpResponse,
} from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { ResponseError } from "@Front-end/seed/utils/interfaces";
import { LocalizeRouterService } from "@gilsdav/ngx-translate-router";
import {
    catchError,
    map,
    Observable,
    throwError,
} from "rxjs";

export const sessionExpiredInterceptor: HttpInterceptorFn = (req, next) => {
    const router: Router = inject(Router);
    const localizeService: LocalizeRouterService = inject(LocalizeRouterService);
    const location: Location = inject(Location);
    return next(req).pipe(
        map((event) => {
            const currentUrl = location.path();

            if (
                event instanceof HttpResponse
                && event.status === 200
                && (event?.body as { error: ResponseError })?.error
                && (event?.body as { error: { code: number } })?.error?.code === 403
                && currentUrl.includes("/profile")
            ) {
                void router.navigate([localizeService.translateRoute("/")]);
            }

            return event;
        }),
        catchError((error: HttpErrorResponse): Observable<never> => throwError(() => error)),
    );
};
